export default "__VITE_ASSET__0b22c356__"